import './bootstrap';
import Vue from 'vue';
import store from './store/index.js';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
// import "https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css";
import '../sass/app.scss';

import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
// import VuePdf from 'vue-pdf'
import { extend, ValidationProvider, ValidationObserver, Validator } from 'vee-validate';
import { localize } from 'vee-validate';
import ja from 'vee-validate/dist/locale/ja.json';
import * as DefaultRules from 'vee-validate/dist/rules';
import * as ValidationCustomRules from './common/validationCustomRules.js';

import NoAuthLayoutComponent from './components/layout/NoAuthLayoutComponent.vue';
import AuthLayoutComponent from './components/layout/AuthLayoutComponent.vue';
import HeaderComponent from './components/common/HeaderComponent.vue';
import FooterComponent from './components/common/FooterComponent.vue';
import NavigationComponent from './components/common/NavigationComponent.vue';
import DashboardNavigationMenuComponent from './components/common/DashboardNavigationMenuComponent.vue';
import AgreementLayoutComponent from './components/layout/AgreementLayoutComponent.vue';
import TemporaryAuthLayoutComponent from './components/layout/TemporaryAuthLayoutComponent.vue';

// ログイン
import LoginComponent from './components/login/LoginComponent.vue';
import LogoutComponent from './components/login/LogoutComponent.vue';

// パスワードリセット
import PasswordResetComponent from './components/login/PasswordResetComponent.vue';
import PasswordResetCompleteComponent from './components/login/PasswordResetCompleteComponent.vue';
import PasswordResetInputComponent from './components/login/PasswordResetInputComponent.vue';

// ユーザ関連
import InitializeComponent from './components/user/InitializeComponent.vue';
// import UserCreateComponent from './components/user/CreateComponent.vue';

// 署名・契約書
import AgreementSelectComponent from './components/agreement/SelectComponent.vue';
import AgreementSelectTemplateComponent from './components/agreement/SelectTemplateComponent.vue';
import AgreementInputSelectTemplateComponent from './components/agreement/InputSelectTemplateComponent.vue';
import AgreementInfoComponent from './components/agreement/InfoComponent.vue';
import AgreementAddressComponent from './components/agreement/AddressComponent.vue';
import AgreementConfirmComponent from './components/agreement/ConfirmComponent.vue';
import AgreementAllListComponent from './components/agreement/AllListComponent.vue';

// 一括送信
import MutipleSendSelectTemplateComponent from './components/multipleSend/SelectTemplateComponent.vue';
import MutipleSendConfirmComponent from './components/multipleSend/ConfirmComponent.vue';
import MutipleSendTimelineComponent from './components/multipleSend/TimelineComponent.vue';


import TimelineComponent from './components/agreement/TimelineComponent.vue';
import PdfThumbComponent from './components/agreement/PdfThumbComponent.vue';
import PdfThumbComponent2 from './components/agreement/PdfThumbComponent2.vue';

import PdfUploadComponent from './components/agreement/PdfUploadComponent.vue';
import AuthorizerDialogComponent from './components/agreement/AuthorizerDialogComponent.vue';
import SignerDialogComponent from './components/agreement/SignerDialogComponent.vue';
import WorkflowComponent from './components/agreement/WorkflowComponent.vue';
import SharingDialogComponent from './components/agreement/SharingDialogComponent.vue';

import PdfDocumentComponent from './components/contractInput/PdfDocumentComponent.vue';
import ContractPdfPageComponent from './components/contractInput/PdfPageComponent.vue';
import ContractInputComponent from './components/contractInput/ContractInputComponent.vue';
import AddInputComponent from './components/contractInput/AddInputComponent.vue';
import DraggableInputComponent from './components/contractInput/DraggableInputComponent.vue';
import TextEditAreaComponent from './components/contractInput/TextEditAreaComponent.vue';
import SelectEditAreaComponent from './components/contractInput/SelectEditAreaComponent.vue';
import CheckboxEditAreaComponent from './components/contractInput/CheckboxEditAreaComponent.vue';
import SealEditAreaComponent from './components/contractInput/SealEditAreaComponent.vue';
import SealInputDialogComponent from './components/contractInput/SealInputDialogComponent.vue';
import SealUploadComponent from './components/contractInput/SealUploadComponent.vue';
import SearchSealComponent from './components/contractInput/SearchSealComponent.vue';
import DestinationListComponent from './components/contractInput/DestinationListComponent.vue';

// ワークフロー 署名 画面認証
import AuthenticateComponent from './components/workflow/AuthenticateComponent.vue';
import AuthenticateWithCodeComponent from './components/workflow/AuthenticateWithCodeComponent.vue';
// import TwoFactorAuthenticateComponent from './components/workflow/TwoFactorAuthenticateComponent.vue';
// import TwoFactorAuthenticateWithCodeComponent from './components/workflow/TwoFactorAuthenticateWithCodeComponent.vue';
// import TwoFactorAuthenticateDialogComponent from './components/workflow/TwoFactorAuthenticateDialogComponent.vue';
// import TwoFactorAuthenticateSetDialogComponent from './components/workflow/TwoFactorAuthenticateSetDialogComponent.vue';
import AuthenticateCompleteComponent from './components/workflow/AuthenticateCompleteComponent.vue';
import AuthenticateRejectComponent from './components/workflow/AuthenticateRejectComponent.vue';
import AuthenticateTransferComponent from './components/workflow/AuthenticateTransferComponent.vue';
import AuthenticateTransferAuthorizerComponent from './components/workflow/AuthenticateTransferAuthorizerComponent.vue';
import AuthenticateTransferredComponent from './components/workflow/AuthenticateTransferredComponent.vue';

// 文書管理
import IndexComponent from './components/documentManagement/IndexComponent.vue';
import SummaryComponent from './components/documentManagement/SummaryComponent.vue';
import ViewComponent from './components/documentManagement/ViewComponent.vue';
import UserDefinedComponent from './components/documentManagement/UserDefinedComponent.vue';
import SubSearchComponent from './components/documentManagement/SubSearchComponent.vue';
import AllDocumentComponent from './components/documentManagement/AllDocumentComponent.vue';

// テンプレート
import TemplateLayoutComponent from './components/layout/TemplateLayoutComponent.vue';
import TemplateIndexComponent from './components/template/TemplateIndexComponent.vue';
import TemplateSelectComponent from './components/template/TemplateSelectComponent.vue';
import TemplateInfoComponent from './components/template/TemplateInfoComponent.vue';
import TemplateAddressComponent from './components/template/TemplateAddressComponent.vue';
import TemplateAuthorDialogComponent from './components/template/TemplateAuthorizerDialogComponent.vue';
import TemplateSignerDialogComponent from './components/template/TemplateSignerDialogComponent.vue';
import TemplateContractInputComponent from './components/template/TemplateContractInputComponent.vue';
import TemplatePdfDocumentComponent from './components/template/TemplatePdfDocumentComponent.vue';
import TemplateCheckboxEditAreaComponent from './components/template/TemplateCheckboxEditAreaComponent.vue';
import TemplateSealEditAreaComponent from './components/template/TemplateSealEditAreaComponent.vue';
import TemplateTextEditAreaComponent from './components/template/TemplateTextEditAreaComponent.vue';
import TemplateDraggableInputComponent from './components/template/TemplateDraggableInputComponent.vue';
import TemplateTimelineComponent from './components/template/TemplateTimelineComponent.vue';
import TemplateOverviewComponent from './components/template/TemplateOverviewComponent.vue';
import TemplateOverViewWorkflowComponent from './components/template/TemplateOverViewWorkflowComponent.vue';
import TemplateContractPreviewComponent from './components/template/TemplateContractPreviewComponent.vue';

// 一括送信テンプレート
import MultipleSendTemplateLayoutComponent from './components/layout/TemplateLayoutComponent.vue';
import MultipleSendTemplateSelectComponent from './components/multipleSendTemplate/TemplateSelectComponent.vue';
import MultipleSendTemplateInfoComponent from './components/multipleSendTemplate/TemplateInfoComponent.vue';
import MultipleSendTemplateAddressComponent from './components/multipleSendTemplate/TemplateAddressComponent.vue';
import MultipleSendTemplateContractInputComponent from './components/multipleSendTemplate/TemplateContractInputComponent.vue';
import MultipleSendTemplateOverviewComponent from './components/multipleSendTemplate/TemplateOverviewComponent.vue';
import MultipleSendTemplatePdfDocumentComponent from './components/multipleSendTemplate/TemplatePdfDocumentComponent.vue';
import MultipleSendTemplateDraggableInputComponent from './components/multipleSendTemplate/TemplateDraggableInputComponent.vue';

import SignLayoutComponent from './components/layout/SignLayoutComponent.vue';
import SignInputComponent from './components/workflow/SignInputComponent.vue';
import SignInputFieldComponent from './components/workflow/SignInputFieldComponent.vue';
import SignPdfDocumentComponent from './components/workflow/PdfDocumentComponent.vue';
import SignPdfPageComponent from './components/workflow/PdfPageComponent.vue';
import SignSealInputDialogComponent from './components/workflow/SealInputDialogComponent.vue';
import SignSealUploadComponent from './components/workflow/SealUploadComponent.vue';
import SignSearchSealComponent from './components/workflow/SearchSealComponent.vue';
import DestinationTimelineComponent from './components/workflow/DestinationTimelineComponent.vue';
import SignInputNavigationComponent from './components/workflow/SignInputNavigationComponent.vue';
import SignatureMethodComponent from './components/workflow/SignatureMethodComponent.vue';

// Web申込み（管理者アカウント登録）
import ApplyComponent from './components/webApplication/ApplyComponent.vue';
import ApplyCompleteComponent from './components/webApplication/ApplyCompleteComponent.vue';
import AdminUserCreateComponent from './components/webApplication/CreateComponent.vue';
import ApplyFreeComponent from './components/webApplication/ApplyFreeComponent.vue';
import ApplyFreeCompleteComponent from './components/webApplication/ApplyFreeCompleteComponent.vue';
import AdminUserCreateFreeComponent from './components/webApplication/CreateFreeComponent.vue';

// 管理 ログ一覧
import ManagementLogListComponent from './components/managementLogList/ManagementLogListComponent.vue';


// 組織
import OrganizationsComponent from './components/organization/IndexComponent.vue';

// ヘルプ
import HelpCategoriesComponent from './components/help/HelpCategoriesComponent.vue';
import HelpArticlesComponent from './components/help/HelpArticlesComponent.vue';
import HelpArticlesSearchResultsComponent from './components/help/HelpArticlesSearchResultsComponent.vue';
import HelpArticlesDetailsComponent from './components/help/HelpArticlesDetailsComponent.vue';

// ダッシュボード
import DashboardComponent from './components/dashboard/DashboardComponent.vue';
import DashboardSendCountComponent from './components/dashboard/DashboardSendCountComponent.vue';

// 契約ステータス
import ApplyingComponent from './components/contractStatus/ApplyingComponent.vue';
import VerificationComponent from './components/contractStatus/VerificationComponent.vue';
import RecievedComponent from './components/contractStatus/RecievedComponent.vue';
import DraftComponent from './components/contractStatus/DraftComponent.vue';
import ConclusionComponent from './components/contractStatus/ConclusionComponent.vue';
import RejectedComponent from './components/contractStatus/RejectedComponent.vue';
// メンバー
import UsersComponent from './components/user/UsersComponent.vue';
import UsersConsentComponent from './components/user/UsersConsentComponent.vue';
import UserConsentCompleteComponent from './components/user/UserConsentCompleteComponent.vue';
import UserDeclineCompleteComponent from './components/user/UserDeclineCompleteComponent.vue';
// グループメンバー
import OrganizationUsersComponent from './components/organizationUsers/OrganizationUsersComponent.vue';
// 企業情報
import CompaniesComponent from './components/companie/CompaniesComponent.vue';
// 支払方法
import InvoicesComponent from './components/Invoice/InvoicesComponent.vue';

// 契約先企業
import ContractDestinationCompaniesComponent from './components/contractDestination/ContractDestinationCompaniesComponent';
// 契約先担当者
import ContractDestinationMembersComponent from './components/contractDestination/ContractDestinationMembersComponent';
// お知らせ
import NotificationsComponent from './components/notification/NotificationsComponent';
// 各種ログ
import UsageLogsComponent from './components/usagelogs/UsageLogsComponent';
// 請求金額確認
import BillsComponent from './components/bill/BillsComponent';

import WebViewerComponent from './components/WebViewerComponent.vue';
import TestPdfComponent from './components/TestPdfComponent.vue';
import PdfPageComponent from './components/PdfPageComponent.vue';

// 個人用印影一覧
import IndividualImprintsComponent from './components/individualImprints/IndividualImprintsComponent.vue';
import IndividualImprintsAddDialogComponent from './components/individualImprints/IndividualImprintsAddDialogComponent.vue';

// 企業用印影一覧
import CompanyImprintsComponent from './components/companyImprints/CompanyImprintsComponent.vue';
import CompanyImprintsAddDialogComponent from './components/companyImprints/CompanyImprintsAddDialogComponent.vue';

// プラン変更一覧
import PlanListComponent from './components/plan/PlanListComponent.vue';
// プラン変更更新
import PlanChangeComponent from './components/plan/PlanChangeComponent.vue';

// アクセス制限
import AccessLimitComponent from './components/accessLimit/AccessLimitComponent.vue';

// 一括検証
import SignatureValidationComponent from './components/signatureValidation/IndexComponent.vue';

// セキュリティ（二要素認証）
// import twoFactorAuthenticationIndexComponent from './components/twoFactorAuthentication/twoFactorAuthenticationIndexComponent.vue';
// import twoFactorAuthenticationSettingNumberInputComponent from './components/twoFactorAuthentication/twoFactorAuthenticationSettingNumberInputComponent.vue';
// import twoFactorAuthenticationSettingCodeInputComponent from './components/twoFactorAuthentication/twoFactorAuthenticationSettingCodeInputComponent.vue';

Vue.use(Vuetify);

// VeeValidate デフォルトルールを全て読み込み
for (const rule in DefaultRules) {
    extend(rule, DefaultRules[rule]);
}
// VeeValidate 自分で実装したルールを全て読み込み
for (const rule in ValidationCustomRules) {
    extend(rule, ValidationCustomRules[rule]);
}
localize('ja', ja); // 日本語に設定
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('vue-draggable-resizable', VueDraggableResizable);

// その他
import ContactComponent from './components/others/ContactComponent.vue';
import ContactCompleteComponent from './components/others/ContactCompleteComponent.vue';
import TermsComponent from './components/others/TermsComponent.vue';
import LawComponent from './components/others/LawComponent.vue';
import CompanyComponent from './components/others/CompanyComponent.vue';

Vue.component('header-component', HeaderComponent);
Vue.component('footer-component', FooterComponent);
Vue.component('navigation-component', NavigationComponent);
Vue.component('dashboard-navigation-menu-component', DashboardNavigationMenuComponent);
Vue.component('login-component', LoginComponent);
Vue.component('initialize-component', InitializeComponent);
Vue.component('apply-component', ApplyComponent);
Vue.component('apply-complete-component', ApplyCompleteComponent);
Vue.component('admin-user-create-component', AdminUserCreateComponent);
Vue.component('apply-free-component', ApplyFreeComponent);
Vue.component('apply-free-complete-component', ApplyFreeCompleteComponent);
Vue.component('admin-user-create-free-component', AdminUserCreateFreeComponent);
Vue.component('organizations-component', OrganizationsComponent);
Vue.component('help-categories-component', HelpCategoriesComponent);
Vue.component('help-articles-component', HelpArticlesComponent);
Vue.component('help-articles-search-results-component', HelpArticlesSearchResultsComponent);
Vue.component('help-articles-details-component', HelpArticlesDetailsComponent);
Vue.component('contact-component', ContactComponent);
Vue.component('contact-complete-component', ContactCompleteComponent);
Vue.component('logout-component', LogoutComponent);
Vue.component('password-reset-component', PasswordResetComponent);
Vue.component('password-reset-complete-component', PasswordResetCompleteComponent);
Vue.component('password-reset-input-component', PasswordResetInputComponent);

// 署名・契約
Vue.component('agreement-select-component', AgreementSelectComponent);
Vue.component('agreement-select-template-component', AgreementSelectTemplateComponent);
Vue.component('agreement-input-select-template-component', AgreementInputSelectTemplateComponent);
Vue.component('agreement-info-component', AgreementInfoComponent);
Vue.component('agreement-address-component', AgreementAddressComponent);
Vue.component('agreement-confirm-component', AgreementConfirmComponent);
Vue.component('agreement-all-list-component', AgreementAllListComponent);

// 一括送信
Vue.component('multiple-send-select-template-component', MutipleSendSelectTemplateComponent);
Vue.component('multiple-send-confirm-component', MutipleSendConfirmComponent);
Vue.component('multiple-send-timeline-component', MutipleSendTimelineComponent);

Vue.component('timeline-component', TimelineComponent);
Vue.component('pdf-thumb-component', PdfThumbComponent);
Vue.component('pdf-thumb-component2', PdfThumbComponent2);

Vue.component('pdf-upload-component', PdfUploadComponent);
Vue.component('authorizer-dialog-component', AuthorizerDialogComponent);
Vue.component('signer-dialog-component', SignerDialogComponent);
Vue.component('workflow-component', WorkflowComponent);
Vue.component('sharing-dialog-component', SharingDialogComponent);

// 文書管理
Vue.component('alert-component', require('./components/documentManagement/AlertComponent.vue').default);
Vue.component('file-index-context-menu-component', require('./components/documentManagement/FileIndexContextMenuComponent.vue').default);
Vue.component('index-dot-menu-component', require('./components/documentManagement/IndexDotMenuComponent.vue').default);
Vue.component('cabinet-folder-file-control-dialog-component', require('./components/documentManagement/CabinetFolderFileControlDialogComponent.vue').default);
Vue.component('cabinet-create-component', require('./components/documentManagement/CabinetCreateComponent.vue').default);
Vue.component('over-view-work-flow-component', require('./components/documentManagement/OverViewWorkflowComponent.vue').default);
Vue.component('contract-preview-component', require('./components/documentManagement/ContractPreviewComponent.vue').default);
Vue.component('pdf-preview-document-component', require('./components/documentManagement/PdfPreviewDocumentComponent.vue').default);
Vue.component('pdf-preview-page-component', require('./components/documentManagement/PdfPreviewPageComponent.vue').default);
// Vue.component('pdf-document-preview-component', require('./components/documentManagement/PdfDocumentPreviewComponent.vue').default);

Vue.component('view-input-item-component', require('./components/documentManagement/ViewInputItemComponent.vue').default);
Vue.component('document-import-component', require('./components/documentManagement/DocumentImportComponent.vue').default);
Vue.component('sub-search-component', SubSearchComponent);
Vue.component('all-document-component', AllDocumentComponent);

// テンプレート
Vue.component('template-index-component', TemplateIndexComponent);
Vue.component('template-select-component', TemplateSelectComponent);
Vue.component('template-info-component', TemplateInfoComponent);
Vue.component('template-address-component', TemplateAddressComponent);
Vue.component('template-author-dialog-component',TemplateAuthorDialogComponent);
Vue.component('template-signer-dialog-component',TemplateSignerDialogComponent);
Vue.component('template-contract-input-component', TemplateContractInputComponent);
Vue.component('template-pdf-document-component', TemplatePdfDocumentComponent);
Vue.component('template-checkbox-edit-area-component', TemplateCheckboxEditAreaComponent);
Vue.component('template-seal-edit-area-document-component', TemplateSealEditAreaComponent);
Vue.component('template-text-edit-area-document-component', TemplateTextEditAreaComponent);
Vue.component('template-draggable-input-component', TemplateDraggableInputComponent);
Vue.component('template-timeline-component', TemplateTimelineComponent);
Vue.component('template-overview-component', TemplateOverviewComponent);
Vue.component('template-overview-workflow-component', TemplateOverViewWorkflowComponent);
Vue.component('template-contract-preview-component', TemplateContractPreviewComponent);

// 一括送信テンプレート
Vue.component('multiple-send-template-select-component', MultipleSendTemplateSelectComponent);
Vue.component('multiple-send-template-info-component', MultipleSendTemplateInfoComponent);
Vue.component('multiple-send-template-address-component', MultipleSendTemplateAddressComponent);
Vue.component('multiple-send-template-contract-input-component', MultipleSendTemplateContractInputComponent);
Vue.component('multiple-send-template-overview-component', MultipleSendTemplateOverviewComponent);
Vue.component('multiple-send-template-pdf-document-component', MultipleSendTemplatePdfDocumentComponent);
Vue.component('multiple-send-template-draggable-input-component', MultipleSendTemplateDraggableInputComponent);

Vue.component('pdf-document-component', PdfDocumentComponent);
Vue.component('contract-pdf-page-component', ContractPdfPageComponent);
Vue.component('contract-input-component', ContractInputComponent);
Vue.component('add-input-component', AddInputComponent);
Vue.component('draggable-input-component', DraggableInputComponent);
Vue.component('text-edit-area-component', TextEditAreaComponent);
Vue.component('select-edit-area-component', SelectEditAreaComponent);
Vue.component('checkbox-edit-area-component', CheckboxEditAreaComponent);
Vue.component('seal-edit-area-component', SealEditAreaComponent);
Vue.component('seal-input-dialog-component', SealInputDialogComponent);
Vue.component('seal-upload-component', SealUploadComponent);
Vue.component('search-seal-component', SearchSealComponent);
Vue.component('destination-list-component', DestinationListComponent);

// ワークフロー
Vue.component('authenticate-component', AuthenticateComponent);
Vue.component('authenticate-with-code-component', AuthenticateWithCodeComponent);
// Vue.component('two-factor-authenticate-component', TwoFactorAuthenticateComponent);
// Vue.component('two-factor-authenticate-with-code-component', TwoFactorAuthenticateWithCodeComponent);
// Vue.component('two-factor-authenticate-dialog-component', TwoFactorAuthenticateDialogComponent);
// Vue.component('set-two-factor-authenticate-dialog-component', TwoFactorAuthenticateSetDialogComponent);
Vue.component('authenticate-complete-component', AuthenticateCompleteComponent);
Vue.component('authenticate-reject-component', AuthenticateRejectComponent);
Vue.component('authenticate-transfer-component', AuthenticateTransferComponent);
Vue.component('authenticate-transfer-authorizer-component', AuthenticateTransferAuthorizerComponent);
Vue.component('authenticate-transferred-component', AuthenticateTransferredComponent);

Vue.component('sign-layout-component', SignLayoutComponent);
Vue.component('sign-input-component', SignInputComponent);
Vue.component('sign-input-field-component', SignInputFieldComponent);
Vue.component('sign-pdf-document-component', SignPdfDocumentComponent);
Vue.component('sign-pdf-page-component', SignPdfPageComponent);
Vue.component('sign-seal-input-dialog-component', SignSealInputDialogComponent);
Vue.component('sign-seal-upload-component', SignSealUploadComponent);
Vue.component('sign-search-seal-component', SignSearchSealComponent);
Vue.component('destination-timeline-component', DestinationTimelineComponent);
Vue.component('sign-input-navigation-component', SignInputNavigationComponent);
Vue.component('signature-method-component', SignatureMethodComponent);

// ダッシュボード
Vue.component('dashboard-component', DashboardComponent);
Vue.component('dashboard-send-count-component', DashboardSendCountComponent);

// グループメンバー
Vue.component('organization-users-dialog-component',require('./components/organizationUsers/OrganizationUsersDialogComponent.vue').default);
Vue.component('organization-users-add-dialog-component',require('./components/organizationUsers/OrganizationUsersAddDialogComponent.vue').default);
// 契約先企業
Vue.component('contract-destination-companies-add-dialog-component',require('./components/contractDestination/ContractDestinationCompaniesAddDialogComponent.vue').default);
Vue.component('contract-destination-companies-dialog-component',require('./components/contractDestination/ContractDestinationCompaniesDialogComponent.vue').default);
// 契約先担当者
Vue.component('contract-destination-members-add-dialog-component',require('./components/contractDestination/ContractDestinationMembersAddDialogComponent.vue').default);
Vue.component('contract-destination-members-dialog-component',require('./components/contractDestination/ContractDestinationMembersDialogComponent.vue').default);
// 請求金額確認
Vue.component('bills-dialog-component',require('./components/bill/BillsDialogComponent.vue').default);
// メンバー
Vue.component('users-dialog-component',require('./components/user/UsersDialogComponent.vue').default);
Vue.component('users-invitation-dialog-component',require('./components/user/UsersInvitationDialogComponent.vue').default);

// 共通コンポーネント
Vue.component('delete-dialog-component',require('./components/common/DeleteDialogComponent.vue').default);
Vue.component('label-component',require('./components/common/LabelComponent.vue').default);
Vue.component('badge-component',require('./components/common/BadgeComponent.vue').default);
Vue.component('date-picker-component',require('./components/common/DatePickerComponent.vue').default);
Vue.component('date-picker-mini-component',require('./components/common/DatePickerMiniComponent.vue').default);
Vue.component('progress-status-component',require('./components/common/ProgressStatusComponent.vue').default);
Vue.component('simple-dialog-component', require('./components/common/SimpleDialogComponent.vue').default);
Vue.component('input-dialog-component', require('./components/common/InputDialogComponent.vue').default);
Vue.component('message-component', require('./components/common/MessageComponent.vue').default);
Vue.component('button-component', require('./components/common/ButtonComponent.vue').default);
Vue.component('pagination-component', require('./components/common/PaginationComponent.vue').default);
Vue.component('edit-group-component', require('./components/common/EditGroupDialogComponent.vue').default);
Vue.component('select-component', require('./components/common/SelectComponent.vue').default);
Vue.component('single-select-component', require('./components/common/SingleSelectComponent.vue').default);
Vue.component('text-field-component', require('./components/common/TextFieldComponent.vue').default);

// PDF表示関連
Vue.component('web-viewer-component', WebViewerComponent);
Vue.component('test-pdf-component', TestPdfComponent);
Vue.component('pdf-page-component', PdfPageComponent);

// 個人用印影一覧
Vue.component('individualimprints-component', IndividualImprintsComponent);
Vue.component('individualimprints-add-dialog-component', IndividualImprintsAddDialogComponent);

// 企業用印影一覧
Vue.component('companyimprints-component', CompanyImprintsComponent);
Vue.component('companyimprints-add-dialog-component', CompanyImprintsAddDialogComponent);

// プラン変更
Vue.component('planlist-component', PlanListComponent);
Vue.component('plan-change-component', PlanChangeComponent);

// アクセス制限の設定
Vue.component('access-limit-component', AccessLimitComponent);

// 一括検証
Vue.component('signature-validation-component', SignatureValidationComponent);

// セキュリティ（二要素認証）
// Vue.component('two-factor-authentication-index-component', twoFactorAuthenticationIndexComponent);
// Vue.component('two-factor-authentication-setting-number-input-component', twoFactorAuthenticationSettingNumberInputComponent);
// Vue.component('two-factor-authentication-setting-code-input-component', twoFactorAuthenticationSettingCodeInputComponent);

//Tabボタンが押下後、クリアボタンにフォーカスが外す
Vue.directive('disabled-icon-focus', {
        bind(el) {
            el.querySelectorAll('.v-input__icon button').forEach(x => x.setAttribute('tabindex', -1));
        },
        componentUpdated(el) {
            el.querySelectorAll('.v-input__icon button').forEach(x => x.setAttribute('tabindex', -1));
        }
});

new Vue({
    el: '#app',
    store: store,
    vuetify: new Vuetify({
        icons: {
            iconfont: 'mdi',
        },
    }),
    components: {
        'no-auth-layout-component': NoAuthLayoutComponent,
        'temporary-auth-layout-component': TemporaryAuthLayoutComponent,
        'auth-layout-component': AuthLayoutComponent,
        'agreement-layout-component': AgreementLayoutComponent,
        'terms-component': TermsComponent,
        'law-component': LawComponent,
        'company-component': CompanyComponent,
        'invoice-component': InvoicesComponent,
        'index-component': IndexComponent,
        'template-layout-component' : TemplateLayoutComponent,
        'summary-component': SummaryComponent,
        'view-component': ViewComponent,
        'user-defined-component': UserDefinedComponent,
        // ダッシュボード
        'users-consent-component': UsersConsentComponent,
        'users-consented-component': UserConsentCompleteComponent,
        'users-decline-component': UserDeclineCompleteComponent,
        'dashboard-component': DashboardComponent,
        'applying-component': ApplyingComponent,
        'verification-component': VerificationComponent,
        'recieved-component': RecievedComponent,
        'draft-component': DraftComponent,
        'conclusion-component': ConclusionComponent,
        'rejected-component': RejectedComponent,
        'users-component': UsersComponent,
        'organization-users-component': OrganizationUsersComponent,
        'companies-component': CompaniesComponent,
        'contract-destination-companies-component': ContractDestinationCompaniesComponent,
        'contract-destination-members-component': ContractDestinationMembersComponent,
        'notifications-component': NotificationsComponent,
        'usage-logs-component': UsageLogsComponent,
        'bills-component': BillsComponent,
        'management-log-list-component': ManagementLogListComponent,
    }
});

